import styled from 'styled-components';

const hexToRgba = (hex: string, alpha: number) => {
  const sanitized = hex.replace('#', '');
  const r = parseInt(sanitized.substring(0, 2), 16);
  const g = parseInt(sanitized.substring(2, 4), 16);
  const b = parseInt(sanitized.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const PaymentOptions = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
  flex-wrap: wrap;

  @media (max-width: 640px) {
    gap: 8px;
  }
`;

export const PaymentOption = styled.button<{ active?: boolean; color: string }>`
  flex: 1;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 2px solid
    ${({ active, color }) => (active ? color : '#D9DDE3')};
  border-left: ${({ active, color }) =>
    active ? `6px solid ${color}` : '2px solid #D9DDE3'};
  border-radius: 12px;
  background: ${({ active, color }) =>
    active ? hexToRgba(color, 0.06) : '#fff'};
  color: ${({ active, color }) => (active ? color : '#18233A')};
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 12px 8px;
  box-shadow: ${({ active, color }) =>
    active
      ? `0 4px 12px ${hexToRgba(color, 0.2)}`
      : 'none'};

  &:hover {
    border-color: ${({ color }) => color};
    background: ${({ color }) => hexToRgba(color, 0.04)};
  }

  span {
    font-size: 13px;
    font-weight: 600;
    text-align: center;
  }

  @media (max-width: 640px) {
    min-height: 70px;
    span {
      font-size: 11px;
    }
  }
`;

export const IconWrapper = styled.div<{ size?: string }>`
  width: ${(props) => props.size || '24px'};
  height: ${(props) => props.size || '24px'};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: currentColor;
  }
`;
